<template>
  <div
    class="flex justify-center items-center flex-col hover:opacity-50 w-20"
    :class="{
      'opacity-50': !!attrDisabled
    }"
    @click="handleUseTemplet"
  >
    <Icon icon="template.svg" :width="20" :height="20" fill="none" />
    <span class="text-[12px] mt-[5px] opacity-70">我的模板库</span>
  </div>
  <modal-template-list ref="templetModal" />
</template>
<script lang="ts" setup>
import { useEditorStore } from '@/store/use-editor-store';
import { computed, ref } from 'vue';

const editorStore = useEditorStore();
const attrDisabled = computed(() => !!editorStore.attrDisabled);

const templetModal = ref();

const handleUseTemplet = () => {
  if (attrDisabled.value) return;
  templetModal.value.showModal();
};
</script>
